/*
 * @Author: lbh
 * @Date: 2024-09-26 16:02:16
 * @LastEditors: lbh
 * @LastEditTime: 2024-09-26 16:15:15
 * @Description: file content
 */
import "./font.css";

const loca_key = "fontType";
const def = "def";
const max = "max";
const _font = {
  // * 设置为 def 模式
  checkDef() {
    localStorage.setItem(loca_key, def);
    document.body.classList.remove(max);
    document.body.classList.add(def);
  },
  // * 设置为 max 模式
  checkMax() {
    localStorage.setItem(loca_key, max);
    document.body.classList.remove(def);
    document.body.classList.add(max);
  },
  // * 获取当前模式
  getModel() {
    return localStorage.getItem(loca_key) || def;
  },
};

export default {
  install(Vue) {
    Vue.prototype.$font = _font;
    let mod = _font.getModel();
    if (mod == max) _font.checkMax();
    else _font.checkDef();
  },
};
